import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		saveContainer: {
			marginTop: 15,
		},
		// Match heights: the outlined Cancel button's 1px border otherwise renders it shorter
		// than the contained Save button.
		button: {
			minHeight: 36,
		},
		uploadLabel: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
			paddingTop: 9,
		},
		uploadFormControl: {
			alignItems: "flex-start",
		}
	} satisfies Record<string, CSSObject>)
}
